import * as S from "./styles";
import { formatFilename } from "./utilsTextEllipsis";

interface KOGTextEllipsisProps {
	text: string;
	type?: "default" | "file";
	isBold?: boolean;
	justifyContent?: "flex-end" | "flex-start";
}

/**
 * Component for applying ellipsis to texts
 * @param text - The text to be formatted
 * @param type - Type of ellipsis ('default' for common text, 'file' for filenames)
 */
function KOGTextEllipsis({ text, type = "default", isBold = true, justifyContent }: KOGTextEllipsisProps) {
	if (type === "file") {
		const { name: fileName, extension: fileExtension } = formatFilename(text);

		return (
			<S.Container title={text}>
				<S.FileName>{fileName}</S.FileName>
				<S.FileExtension>{fileExtension}</S.FileExtension>
			</S.Container>
		);
	}

	return (
		<S.Container title={text} isBold={isBold} justifyContent={justifyContent}>
			<S.TextEllipsis>{text}</S.TextEllipsis>
		</S.Container>
	);
}
export default KOGTextEllipsis;
